import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';


const getAll = async ( params = {} ) => {

  const query = `
    query GetAllSolicitudesTerapia(
      $search          : String, 
      $tokenTerapia    : String,
      $establecimiento : String, 
      $fechaDesde      : Date, 
      $fechaHasta      : Date, 
      $estadoTerapia   : String, 
      $page            : Int, 
      $pageSize        : Int,
      $coberturasFaltantes : Boolean,
      $sesionesIncompletas : Boolean

      $pacienteId      : ID
    ) {
      allSolicitudesTerapia(
        search          : $search,
        tokenTerapia    : $tokenTerapia,
        establecimiento : $establecimiento, 
        fechaDesde      : $fechaDesde, 
        fechaHasta      : $fechaHasta, 
        estadoTerapia   : $estadoTerapia, 
        page            : $page, 
        pageSize        : $pageSize,
        pacienteId      : $pacienteId,
        coberturasFaltantes : $coberturasFaltantes,
        sesionesIncompletas : $sesionesIncompletas

      ) {
        total
        status
        message
        numSinCompletar
        numSinCobertura
        solicitudes {
          id
          token
          fechaProgramada
          numeroOrdenAs400
          resumenClinico
          motivoSolicitud
          fechaCreacion
          cantidad
          detallesTerapia {
                id
                fechaCreacion
                ultimoCambio
                token
                fechaSesion
                horaSesion
                estadoSesion
                dataFormulario
                estado
                urlMspPaciente
                urlMspTitular1
                urlMspTitular2
                urlMspTitular3
          }
          usuarioCreador{
            username
          }
          estadoTerapia
          terapia{
            id
            codigo
            nombre
            precio
            tipoTerapia {
              descripcion
              id
            }
          }
          consultamedica{
            cita{
              fechaCita
              cobSeleccionada{
                id
                descripcion
              }
              paciente{
                id
                persona{
                  primerNombre
                  identificacion
                  primerApellido
                }

              }
              doctor{
                idPersona{
                  primerNombre
                  identificacion
                  primerApellido
                }
              }
              establecimiento{
                id
                Descripcion
              }
            }
          }
        }
      }
    }
  `;

  const variables = {
    ...params
  }

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.allSolicitudesTerapia;
    if( response2.status !== 'Success' ) return null;

    const data = response2
    return data;

  }catch(error){
    console.log('Error al obtener las terapias', error);
    return null;
  }
  
}


const getByToken = async ( tokenTerapia ) => {

  const params = {
    tokenTerapia
  }
  const response = await getAll( params );
  return response.solicitudes[0];
}
const generar005Terapias = async (token) => {

  if(!token) return null;

  const query = `
  query generate005PdfTerapias($tokenTerapia : String!){
     generate005PdfTerapias(tokenTerapia: $tokenTerapia) {
        pdfBase64
        message
        nameFile
    }
}
  `;

  const variables = {
    tokenTerapia : token
  }
  
  try{
    const response = await axios.post(rutas.axios + "api", { query, variables });

    if(response.status !== 200) return null;

    const pdfBase64 = response.data.data.generate005PdfTerapias?.pdfBase64;
    
    if(!pdfBase64) return null;       
    return pdfBase64;

  }catch(error){
    console.error("Error al generar 005:", error);
    return null;
  }
}

const generarTerapiaFisica = async (token) => {

  if(!token) return null;

  const query = `
  query generatePdfTerapiaFisica($tokenTerapia : String!){
     generatePdfTerapiaFisica(tokenTerapia: $tokenTerapia) {
        pdfBase64
        message
        nameFile
    }
}
  `;

  const variables = {
    tokenTerapia : token
  }
  
  try{
    const response = await axios.post(rutas.axios + "api", { query, variables });

    if(response.status !== 200) return null;

    const pdfBase64 = response.data.data.generatePdfTerapiaFisica?.pdfBase64;
    
    if(!pdfBase64) return null;       
    return pdfBase64;

  }catch(error){
    console.error("Error al generar 005:", error);
    return null;
  }
}



const getByAtencion = async ( tokenAtencion ) => {
  
  if( !tokenAtencion ) {
    console.error('token atencion es requerido');
    return null
  }

  const query = `
    query AllAtenmedica($tokenAtencion: String) {
      allAtenmedica(tokenAtencion: $tokenAtencion) {
        total
        status
        message
        atcm {
          id
          token
          
          solicitudterapiaSet{
            id
            token
            terapia{
              id
              codigo
              nombre
            }
            cantidad
            numeroOrdenAs400
            motivoSolicitud
            resumenClinico
            estado
          }
        }
      }
    }
  `;

  const variables = { tokenAtencion };

  try{

    const response = await axios.post(rutas.axios + 'api', { query, variables });
    // console.log('response terapias', response);
    const response2 = response.data.data.allAtenmedica;

    if( response2.status !== 'success' ) return null;
    if( response2.atcm.length === 0 ) return null;
    if( response2.atcm[0].solicitudterapiaSet.length === 0 ) return null;

    const data = response2.atcm[0].solicitudterapiaSet;
    return data;

  }catch(error){
    console.error('Error al obtener las terapias de la atencion', error);
    return null;
  }
}



const processEnvios = async ( tokenAtencion, dataTerapias ) => {

  if(!tokenAtencion) {
    console.error('token de la atencion es requerido');
    return null;
  }

  if(!dataTerapias || dataTerapias.length === 0) {
    console.error('data terapias es requerido');
    return null;
  }

  const query = `
    mutation ProcesarEnviosTerapias(
      $atencionMedica: String!,
      $terapiasToProcess: [processEnviosTerapiasInput!]!
    ) {
      procesarEnviosTerapias(
        atencionMedica: $atencionMedica,
        terapiasToProcess: $terapiasToProcess
      ) {
        message
        status
        terapiasProcesadas
      }
    }
  `;


  const variables = {
    atencionMedica    : tokenAtencion,
    terapiasToProcess : dataTerapias,
  };

  try{
    const response = await axios.post(rutas.axios + "api", { query, variables });

    console.log(response);
    if( response.status !== 200 ) return null;

    const response2 = response.data.data.procesarEnviosTerapias;
    if(response2.status !== 'Success') return null;

    const data = response2.terapiasProcesadas;
    return data;
  }catch(error){
    console.error('Error al registrar las terapias de la atencion', error);
    return null;
  }
}








const processSesiones = async (tokenTerapiaEnviada, dataSesiones) => {

  if(!tokenTerapiaEnviada) {
    console.error('token de la atencion es requerido');
    return null;
  }

  if(!dataSesiones || dataSesiones.length === 0) {
    console.error('data sesiones es requerido');
    return null;
  }

  const query = `
    mutation ProcessSesionesTerapias(
      $terapiaEnviada:String!
      $sesionesToProcess: [processSesionesTerapiasInput]!
    ) {
      processSesionesTerapias(
        terapiaEnviada: $terapiaEnviada
        sesionesToProcess: $sesionesToProcess
      ) {
        message
        status
        sesionesProcesadas
      }
    }
  `;

  const variables = {
    terapiaEnviada     : tokenTerapiaEnviada,
    sesionesToProcess  : dataSesiones,
  };

  try{
    const response = await axios.post(rutas.axios + "api", { query, variables });
    if( response.status !== 200 ) return null;

    const response2 = response.data.data.processSesionesTerapias;
    if(response2.status !== 'Success') return null;

    const data = response2.sesionesProcesadas;

    return data;
  }catch(error){
    console.error('Error al registrar las terapias de la atencion', error);
    return null;
  }

}


const updateByToken = async (tokenTerapia, fieldsToUpdate) => {

  if(!tokenTerapia) return null;

  const query = `
    mutation UpdateTerapiaEnviada(
      $tokenTerapiaEnviada:String!
      $fieldsToUpdate:TerapiaFieldsToUpdate!
    ) {
      updateTerapiaEnviada(
        tokenTerapiaEnviada : $tokenTerapiaEnviada
        fieldsToUpdate      : $fieldsToUpdate
      ) {
        message
        status
        terapiaUpdated
      }
    }

  `;

  const variables = {
    tokenTerapiaEnviada : tokenTerapia,
    fieldsToUpdate      : { ...fieldsToUpdate }
  }


  try{
    const response = await axios.post(rutas.axios + "api", { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.updateTerapiaEnviada;
    if(response2.status !== 'success') return null;

    const data = response2.terapiaUpdated;
    return data;

  }catch(error){
    console.error('Error al registrar las terapias de la atencion', error);
    return null;
  }
}




export const terapiasService = {
  getAll,
  getByToken,
  getByAtencion,
  processEnvios,
  updateByToken,
  
  processSesiones,
  generar005Terapias,
  generarTerapiaFisica
}